import type { GetServerSidePropsContext } from 'next';

import { GenericPageLayout } from '@/components/layout/layout.page.component';
import { getCurrencyConverterPageData } from '@/utils';

export const getServerSideProps = async (
  initialProps: GetServerSidePropsContext,
) => {
  return await getCurrencyConverterPageData(initialProps);
};

export default GenericPageLayout;
